import {getData, postData} from './redux_data';
import {
    GET_TIPO_FICHA,
    MODIFY_TIPO_FICHA,
    ADD_TIPO_FICHA,
    DELETE_TIPO_FICHA,
    UPDATE_TIPO_FICHA,
} from '../constants/action_types';

export function getTipoFichaList() {
    return getData('CvTipoFichas', GET_TIPO_FICHA);
}

export function modifyTipoFicha(tipoFicha) {
    return (dispatch, getState) => {
        dispatch({ type: MODIFY_TIPO_FICHA, payload: tipoFicha });
    }
}

export function addTipoFicha(tipoFicha) {
    return (dispatch, getState) => {
        dispatch({ type: ADD_TIPO_FICHA, payload: tipoFicha });
    }
}

export function removeTipoFicha(tipoFicha) {
    return (dispatch, getState) => {
        dispatch({ type: DELETE_TIPO_FICHA, payload: tipoFicha });
    }
}

export function updateTipoFichaListDB (tipoFichaList) {
    return postData('CvTipoFichas/lista', UPDATE_TIPO_FICHA, tipoFichaList, 'Tipos de ficha actualizados', undefined);

}

